import PubSub from 'pubsub-js';
import Unity from 'react-unity-webgl';
import { useContext, useState, useEffect, useRef } from 'react';
import { unitycontext } from '../../../hooks/useUnityContext';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  selectAllOnboardingData,
  selectCuratorInitialized,
  setCuratorLoader,
  setUnityLoaded,
} from '../../../redux/slicers/admin/curatorSlicer';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCanvasFrameHeight,
  setCanvasFrameWidth,
} from '../../../redux/slicers/camera/cameraSettings';
import { OPEN_PROJECT_ID } from '../../../config/constant/curatorConstants';
import { UnityEvent } from '../../../helpers/unityPubSub';
import {
  selectGlobalDPR,
  utilitiesSelector,
} from '../../../redux/slicers/utilities/utilitiesSlicer';
import { DEFAULT_DPR } from '../../../config/constant/unityConstants';
import { isUserOnboarding } from '../../gamificationTooltip/helpers';
import { LogCurator } from '../../../helpers/logEvents';
import { useStaticPermissions } from '../../../hooks/usePermissions';
import { PERMISSION } from '../../../constants/permissionConstants';
import { LS_LF_DEBUGGER_CSG_OPERATION_ENABLED } from '../../../redux/slicers/admin/curatorDebuggerSlicer';
import { isRetailAutomation } from '../../Configurator/utils';
import { useUserContext } from '../../../contexts/UserContext';
let targetUnityWidth = '100%';
let targetUnityHeight = '100%';

export const UnityCanvasContainer = ({ data, className='', isProject }) => {
  const dispatch = useDispatch();
  const dpr = useSelector(selectGlobalDPR);
  const { unityContext, mainController, cameraModule, handleLoad, handleLoadProject, sentryUnityModule, handleLoadProjectBuilder } =
    useContext(unitycontext);
  const {currentUser} = useUserContext()
  const { type, room_id } = useParams();
  const blurListenerRef = useRef();
  const containerRef = useRef(null);
  const curatorInitialized = useSelector(selectCuratorInitialized);
  const _data = {...data};
  const { hasPermission } = useStaticPermissions();
  const isBuilder = type === 'builder';

  // checking here, if user have permission to perform boolean operation or not
  if(hasPermission(PERMISSION.BOOLEAN_OPERATION)) {
    _data['canPerformBooleanOperation'] = true;
  } else {
    _data['canPerformBooleanOperation'] = false;
  }

  // checking and sending if CSG operation is enabled or not
  const csgOperationEnabled = localStorage.getItem(LS_LF_DEBUGGER_CSG_OPERATION_ENABLED);
  if(csgOperationEnabled === 'false' || csgOperationEnabled === false) {
    _data['isCSGBooleanOperation'] = false;
  } else {
    _data['isCSGBooleanOperation'] = true;
  }

  const handleMouseOver = (e) => {
    mainController.MousePointerReceiver(true);

    if (
      document.activeElement.tagName === 'INPUT' &&
      ['text', 'number'].includes(document.activeElement.type)
    ) {
      // do not focus unity if input element has focus
      blurListenerRef.current = () => {
        unityContext.send('MainController', 'WebglKeyBoard', 'True');
      };
      window.addEventListener('blur', blurListenerRef.current);

      return;
    }

    unityContext.send('MainController', 'WebglKeyBoard', 'True');
    window.LFApp.unityHovered = true;
  };
  const handleUnityL = (e) => {
    unityContext.send('MainController', 'WebglKeyBoard', 'False');
    mainController.MousePointerReceiver(false);
    window.removeEventListener('blur', blurListenerRef.current);
    window.LFApp.unityHovered = false;
  };

  useEffect(() => {
    return () => {
      window.removeEventListener('blur', blurListenerRef.current);
    };
  }, []);

  useEffect(() => {
    // const recalculateCanvasSize = () => {
    //   if (!containerRef.current) return;

    //   // const maxWidth = 1920;
    //   // const maxHeight = 1080;

    //   // const maxWidth = 1280;
    //   // const maxHeight = 864;

    //   const maxWidth = 20000;
    //   const maxHeight = 20000;
    //   const { clientWidth, clientHeight } = containerRef.current;

    //   const container = document.querySelector('#unityCanvasContainer');
    //   if (clientWidth <= maxWidth && clientHeight <= maxHeight) {
    //     container.style.width = '100%';
    //     container.style.height = '100%';
    //     container.style.transform = 'scale(1) translate(-50%, -50%)';
    //     return;
    //   }

    //   const deltaWidth = clientWidth / maxWidth;
    //   const deltaHeight = clientHeight / maxHeight;

    //   let width, height;
    //   if (deltaWidth > deltaHeight) {
    //     width = maxWidth;
    //     height = clientHeight / deltaWidth;
    //   } else {
    //     height = maxHeight;
    //     width = clientWidth / deltaHeight;
    //   }

    //   const scale = clientWidth / width;
    //   const translate = 50 / scale;

    //   // container.style.width = `${width}px`;
    //   // container.style.height = `${height}px`
    //   // container.style.transform = `scale(${scale}) translate(-${translate}%, -${translate}%)`;

    // }

    const recalculateCanvasSize = () => {
      if (!containerRef.current) return;
      if (true) return; // disable this logic

      const maxWidth = 1920;
      const maxHeight = 1080;
      const ratioToBe = maxWidth / maxHeight;

      let targetRatio;

      const { clientWidth, clientHeight } = containerRef.current;
      const unityCanvasRatio = clientWidth / clientHeight;

      const unityCanvas = document.querySelector('#unity-canvas-1');
      if (clientWidth <= maxWidth && clientHeight <= maxHeight) {
        unityCanvas.style.width = '100%';
        unityCanvas.style.height = '100%';
        unityCanvas.style.transform = 'scale(1)'; // translate(-50%, -50%)';
        return;
      }

      if (unityCanvasRatio > ratioToBe) {
        // canvas is wide

        targetRatio = clientWidth / maxWidth;
      } else {
        // canvas is tall

        targetRatio = clientHeight / maxHeight;
      }

      targetUnityWidth = clientWidth / targetRatio;
      targetUnityHeight = clientHeight / targetRatio;

      unityCanvas.style.width = `${targetUnityWidth}px`;
      unityCanvas.style.height = `${targetUnityHeight}px`;
      unityCanvas.style.transform = `scale(${targetRatio})`; // translate(-${translate}%, -${translate}%)`;
      unityCanvas.style.transformOrigin = 'top left';
    };

    // todo: refactor this resize function
    const handleResize = (e) => {
      if (!containerRef.current) return;
      const width = containerRef.current.clientWidth;
      const height = containerRef.current.clientHeight;

      dispatch(setCanvasFrameWidth(width));
      dispatch(setCanvasFrameHeight(height));

      cameraModule.GetCanvasSizeReceiver({
        canvas_width: width,
        canvas_height: height,
      });

      recalculateCanvasSize();
    };

    // when curator loads sidebar appears with animation, we want to update camera frame during this animation -> or we can use settimeout doesn't matter
    let i = 0;
    const timerId = setInterval(() => {
      handleResize();
      i++;
      if (i > 8) clearInterval(timerId);
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [curatorInitialized]);

  useEffect(() => {
    unityContext.on('loaded', function () {
      LogCurator('loaded unity');
      localStorage.removeItem('instantiatedProps');
      const isOnboardingState = isUserOnboarding();
      PubSub.publish(UnityEvent.UNITY_LOADED);
      console.log('_data_data', _data);
      setTimeout(() => {
        sentryUnityModule.initUser({
          user_id: currentUser?.user?.id,
          user_email: currentUser?.user?.email,
          organization_id: currentUser?.organization_detail?.id,
          organization_name: currentUser?.organization_detail?.name,
          environment : process.env.REACT_APP_ENV,
          url : window.location.href, 
        });
        
        // TODO: check why do we need this timeout
        if (!isBuilder) {
          if (type === 'project' || room_id === OPEN_PROJECT_ID || isOnboardingState || isRetailAutomation() || isProject) {
            handleLoadProject(_data);
          } else {
            handleLoad(_data);
          }
        } else {
          handleLoadProjectBuilder(_data);
        }

        dispatch(setCuratorLoader(true));
        dispatch(setUnityLoaded(true));

        if (window.LFApp.unityHovered) {
          unityContext.send('MainController', 'WebglKeyBoard', 'True');
          mainController.MousePointerReceiver(true);
        } else {
          unityContext.send('MainController', 'WebglKeyBoard', 'False');
          mainController.MousePointerReceiver(false);
        }
      }, 50); // timeout just in case
    });
  }, []);

  return (
    <div
      className={`unity-container ${className}`}
      ref={containerRef}
      onMouseLeave={handleUnityL}
      onMouseOver={handleMouseOver}>
      <div
        id="unityCanvasContainer"
        style={{
          // position: 'absolute',
          // left: '50%',
          // top: '50%',
          // transform: 'scale(1) translate(-50%, -50%)',
          width: '100%',
          height: '100%',
        }}>
        <Unity
          devicePixelRatio={dpr}
          unityContext={unityContext}
          style={{ width: targetUnityWidth, height: targetUnityHeight }}
          width={targetUnityWidth}
          height={targetUnityHeight}
        />
      </div>
    </div>
  );
};
